import React, { useState } from 'react';
import { Button, Form, Row } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';

export function DiscoveryFilter({ handleChanges, handleClicks, state, setState }: any) {
    const [inputTypes, setInputTypes] = useState({
        from: 'text',
        to: 'text',
    });

    function handleTypes(evt: any, type: string) {
        setInputTypes(prev => ({
            ...prev,
            [evt.target.name]: type,
        }));
    }

    return (
        <Form>
            <Row style={{ rowGap: '18px' }}>
                <div className="col-md-2 col-6">
                    <Form.Control
                        placeholder="Company name"
                        className="autocomplete-input"
                        name="displayName"
                        onChange={handleChanges}
                    />
                </div>
                <div className="col-md-2 col-6">
                    <div className="d-flex bg-secondary-o-100 border rounded">
                        <Form.Control
                            placeholder="From :"
                            className="autocomplete-input border-0 cursor-pointer"
                            type={inputTypes.from}
                            name="from"
                            value={state?.from || ''}
                            onFocus={(e: React.ChangeEvent<HTMLInputElement>) => handleTypes(e, 'date')}
                            onBlur={(e: React.ChangeEvent<HTMLInputElement>) => handleTypes(e, 'text')}
                            onChange={handleChanges}
                        />
                        {state?.from && (
                            <Button
                                variant=""
                                className="py-2 px-3 clearBtn btn-hover-bg-secondary"
                                onClick={() => {
                                    setState((prev: any) => ({ ...prev, from: undefined }));
                                }}
                            >
                                <FaTimes fontSize={14} />
                            </Button>
                        )}
                    </div>
                </div>
                <div className="col-md-2 col-6">
                    <div className="d-flex bg-secondary-o-100 border rounded">
                        <Form.Control
                            placeholder="To :"
                            className="autocomplete-input border-0 cursor-pointer"
                            type={inputTypes.to}
                            name="to"
                            value={state?.to || ''}
                            onFocus={(e: React.ChangeEvent<HTMLInputElement>) => handleTypes(e, 'date')}
                            onBlur={(e: React.ChangeEvent<HTMLInputElement>) => handleTypes(e, 'text')}
                            onChange={handleChanges}
                        />
                        {state?.to && (
                            <Button
                                variant=""
                                className="py-2 px-3 clearBtn btn-hover-bg-secondary"
                                onClick={() => {
                                    setState((prev: any) => ({ ...prev, to: undefined }));
                                }}
                            >
                                <FaTimes fontSize={14} />
                            </Button>
                        )}
                    </div>
                </div>
            </Row>
            <Button className="mt-4" onClick={() => handleClicks()}>
                Search
            </Button>
        </Form>
    );
}
